import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useKeycloakContext } from "@wf/keycloak-axios-provider";
import { fetchingUser, clearStore } from "../redux/app/actions";
import { userSelector } from "../redux/app/selectors";

const useInitApp = () => {
  const dispatch = useDispatch();
  const keycloakContext = useKeycloakContext();
  const username = useMemo(() => keycloakContext.getUserData()?.username, [keycloakContext]);
  const fullUserInfo = useSelector(userSelector);

  useEffect(() => {
    dispatch(fetchingUser(username));

    return () => {
      dispatch(clearStore());
    };
  }, [dispatch, username]);

  return !!fullUserInfo;
};

export default useInitApp;
